import React from 'react';
import { EpisodeAsset } from '../../../../queries/ats/titles/types/asset';
import { Source } from '../../../../queries/ats/titles/types/sources';
import { getPreferredRecording } from '../../../../queries/ats/titles/utils/recording-utils';
import { EpisodeProgramThumbnail } from './episode-program-thumbnail';
import { EpisodeSvodThumbnail } from './episode-thumbnail-svod';
import { EpisodeThirdPartyThumbnail } from './episode-thumbnail-thirdparty';
import { EpisodeVodThumbnail } from './episode-thumbnail-vod';
import { RecordedProgramThumbnail } from './recorded-program-thumbnail';

export interface EpisodeThumbnailProps {
  episode: EpisodeAsset;
  source: Source;
}

export function EpisodeThumbnail({ episode, source }: EpisodeThumbnailProps) {
  switch (source.type) {
    case 'program':
      const recording = getPreferredRecording(source, true);
      return recording !== undefined && recording.status === 'completed' ? (
        <RecordedProgramThumbnail episode={episode} recording={recording} />
      ) : (
        <EpisodeProgramThumbnail episode={episode} source={source} />
      );
    case 'vod':
      return <EpisodeVodThumbnail episode={episode} source={source} />;
    case 'svod':
      return <EpisodeSvodThumbnail episode={episode} source={source} />;
    case 'thirdparty':
      return <EpisodeThirdPartyThumbnail episode={episode} source={source} />;
    default:
      throw new Error('Unknown source type');
  }
}
